module.exports = __webpack_public_path__ + "static/media/ma.4eaab8f1.svg";